import { createContext } from 'react';

export type DisplayrDashboardData = {
  dashboardId: string;
  tabName: string;
};

export type SetDisplayrDashboardData = (data: DisplayrDashboardData) => Promise<void>;


export type SigmaDashboardData = {
  warehouse: string | null;
  schema: string | null;
  analysisId?: string | null;
  includeTreatmentClaimCount?: boolean;
  includeEpidemiology?: boolean;
  includeLineOfTherapy?: boolean;
  includeCompliance?: boolean;
  includePersistence?: boolean;
  tabName: string;
};

export type SetSigmaDashboardData = (data: SigmaDashboardData) => Promise<void>;

export type TableauDashboardData = {
  dashboardId: string;
  tabName: string;
};

export type SetTableauDashboardData = (data: TableauDashboardData) => Promise<void>;


export const DisplayrDashboardContext = createContext<DisplayrDashboardData | null>(null);
export const SetDisplayrDashboardContext = createContext<SetDisplayrDashboardData | null>(null);

export const SigmaDashboardContext = createContext<SigmaDashboardData | null>(null);
export const SetSigmaDashboardContext = createContext<SetSigmaDashboardData | null>(null);

export const TableauDashboardContext = createContext<TableauDashboardData | null>(null);
export const SetTableauDashboardContext = createContext<SetTableauDashboardData | null>(null);


